<template>
  <div id="app" class="te-body h-100">
    <router-view />
  </div>
</template>

<script>
import '@/assets/styles/login.min.css';
import '@/assets/styles/te-cutsom.min.css';
import '@/assets/styles/te-listmenu.min.css';
import '@/assets/styles/te-listmodule.min.css';
import '@/assets/styles/te-listModuleV2.min.css';
import '@/assets/styles/te-customize-color.css';
import '@/assets/styles/te-import-popup.min.css';
import '@/assets/styles/te-mcf.min.css';
import 'animate.css/animate.min.css';

export default {
  name: 'App'
};
</script>

<style>
/*
  Fix an issue in vue-bootstrap v2.22.0:
  https://github.com/bootstrap-vue/bootstrap-vue/issues/6961 */
.b-table-sticky-header > .table.b-table > thead > tr > th {
  position: sticky !important;
}
</style>
